/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC, useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  IconButton,
  Link,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useToast
} from '@chakra-ui/react'

import { AiOutlineDelete, AiOutlineUser } from 'react-icons/ai'
import { RiAddLine, RiEye2Fill, RiPencilLine } from 'react-icons/ri'
import { AlertDialogCustom } from '../../Components/AlertDialog'
import { Header } from '../../Components/Header'
import { SearchBox } from '../../Components/Header/SearchBox'
import { Pagination } from '../../Components/Pagination'
import { Sidebar } from '../../Components/Sidebar'
import api from '../../Services/api'
import { format } from 'date-fns'
import { Loader } from '../../Components/Loader'
import NotificationsProps, { NotificationsType } from './Interfaces/NotificationsProps'
import { NOTIFICATIONS_STATUS, NOTIFICATIONS_TYPE } from '../../Services/contants'

interface Props extends NotificationsProps {
  typeLabel: string
}

export const NOTIFICATIONS_TYPE_LABEL: any = {
  'pre-proposal-approvement-boss-sector': 'Nova Pré-proposta',
  'provider-create-boss-sector': 'Aprovação de Prestador',
  info: 'Informativo',
  'pre-proposal-updated-boss-sector': 'Atualização de Pré-proposta'
}

const ProcessTracking: FC = () => {
  const [loading, setLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState({} as Props)
  const [tabIndex, setTabIndex] = useState(0)

  const [page, setPage] = useState(1)
  const [data, setData] = useState<Props[]>([])
  const [total, setTotal] = useState(10)

  const [pageDeleted, setPageDeleted] = useState(1)
  const [dataDeleted, setDataDeleted] = useState<Props[]>([])
  const [totalDeleted, setTotalDeleted] = useState(10)

  const [error, setError] = useState(false)
  const toast = useToast()

  const isWideScreen = useBreakpointValue({
    base: false,
    lg: true
  })

  const updateViewed = useCallback(async (notification_id: string) => {
    try {
      await api.patch(`/notifications/${notification_id}`)
    } catch (error) {
      console.log('erro ao atualizar status da notificação: ', error)
      setError(true)
    }
  }, [])

  const loadNewsNotifications = useCallback(async (pag: number) => {
    setLoading(true)
    try {
      const { data } = await api.get('/process-tracking', {
        params: {
          pag,
          viewed: NOTIFICATIONS_STATUS.not_viewed
        }
      })

      const normalize: any = await Promise.all(data?.data?.map(async (i: any) => {
        return {
          ...i,
          typeLabel: 'Atualização de Processo',
          formattedDate: format(new Date(i.created_at), 'dd/MM/yyyy HH:mm')
        }
      }))

      setPage(pag)
      setData(normalize)
      setTotal(data.total)
    } catch (error) {
      console.log('erro ao pegar notificações: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
    // setData(fakeData)
  }, [updateViewed])

  const loadViewedNotifications = useCallback(async (pag: number) => {
    setLoading(true)
    try {
      const { data } = await api.get('/process-tracking', {
        params: {
          pag,
          viewed: NOTIFICATIONS_STATUS.viewed
        }
      })

      const normalize: any = await Promise.all(data?.data?.map(async (i: any) => {
       

        return {
          ...i,
          typeLabel: 'Atualização de Processo',
          formattedDate: format(new Date(i.created_at), 'dd/MM/yyyy HH:mm')
        }
      }))

      setPageDeleted(pag)
      setDataDeleted(normalize)
      setTotalDeleted(data.total)
    } catch (error) {
      console.log('erro ao pegar notificações: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
    // setData(fakeData)
  }, [updateViewed])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    loadNewsNotifications(page)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    loadViewedNotifications(pageDeleted)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageDeleted])

  const makeBg = useCallback((status: string) => {
    return '#f8de7e'
    // switch (status) {
    //   case status = 'REQUESTED':
    //     return '#f8de7e'

    //   case status = 'PAID':
    //     return '#5dbb63'

    //   case status = 'REFUSED':
    //     return '#fa8072'

    //   default:
    //     return '#F5F50C'
    // }
  }, [])

  const makeColor = useCallback((status: number) => {
    switch (status) {
      case status = NOTIFICATIONS_STATUS.not_viewed:
        return '#993b58'

      case status = NOTIFICATIONS_STATUS.viewed:
        return '#fff'

      default:
        return '#fff'
    }
  }, [])

  const MakeActions = (type: NotificationsType, item: NotificationsProps) => {
    if (type === 'pre-proposal-approvement-boss-sector') {
      return <Button
      href={`/pre-proposal/create/${item?.params?.proposal_id}?notification_id=${item?.id}&action=${item?.type}`}
        as="a"
        size="sm"
        fontSize="sm"
        mr="2"
        bg="wine.200"
        colorScheme="wine"
        height="40px"
        leftIcon={
          <Icon as={RiEye2Fill} fontSize="16" />
        }
      >
      Visualizar
    </Button>
    }

    if (type === 'pre-proposal-updated-boss-sector') {
      return <Button
      href={`/pre-proposal/create/${item?.params?.proposal_id}?notification_id=${item?.id}&action=${item?.type}`}
        as="a"
        size="sm"
        fontSize="sm"
        mr="2"
        bg="wine.200"
        colorScheme="wine"
        height="40px"
        leftIcon={
          <Icon as={RiEye2Fill} fontSize="16" />
        }
      >
      Visualizar
    </Button>
    }

    if (type === 'provider-create-boss-sector') {
      return <Button
      href={`/providers/create/${item?.params?.provider_id}?notification_id=${item?.id}&action=${item?.type}`}
        as="a"
        size="sm"
        fontSize="sm"
        mr="2"
        bg="wine.200"
        colorScheme="wine"
        height="40px"
        leftIcon={
          <Icon as={RiEye2Fill} fontSize="16" />
        }
      >
      Visualizar
    </Button>
    }
  }

  const closeModal = useCallback(() => {
    setSelectedItem({} as Props)
  }, [])

  const hanleDelete = useCallback(async () => {
    const { id } = selectedItem
    try {
      await api.delete(`/notifications/${id}`)

      toast({
        title: 'Sucesso',
        position: 'top',
        isClosable: true,
        status: 'success',
        variant: 'solid'
      })
      setSelectedItem({} as Props)
      loadNewsNotifications(page)
      loadViewedNotifications(pageDeleted)
    } catch (error) {
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
      setSelectedItem({} as Props)
    }
  }, [selectedItem, toast, page, loadNewsNotifications, loadViewedNotifications, pageDeleted])

  return (
    <Box>

      <Header />

      {!!selectedItem?.id && (
        <AlertDialogCustom
          title="Marcar nofiticação como visualizada"
          isOpen={!!selectedItem?.id}
          cancelFunction={closeModal}
          nextFunction={hanleDelete}
        />
      )}

      <Flex w="100%" my="6" maxWidth={1480} mx="auto" px={['4', '4', '6']}>
        <Sidebar />

        <Box flex="1" borderRadius={8} bg="white" p="8">
          <Flex mb="8" justify="space-between" align="center">
            <Heading size="lg" fontWeight="normal" color="wine.primary">
              ATUALIZAÇÕES DE PROCESSOS
            </Heading>

          </Flex>

          {loading
            ? (
            <Flex justify="center">
              <Loader />
            </Flex>
              )
            : error
              ? (
            <Flex justify="center">
              <Text>Erro ao carregar a lista de notificações</Text>
            </Flex>
                )
              : (
                  <Tabs variant='enclosed' mt="10" index={tabIndex} onChange={e => setTabIndex(e)}>
                    <TabList>
                      <Tab>NÃO VISUALIZADAS</Tab>
                      <Tab>VISUALIZADAS</Tab>
                    </TabList>
                    <TabPanels>
                      <TabPanel>
                          <Table colorScheme="blue">
                            <Thead>
                              <Tr>
                                <Th textAlign="center">Notificação</Th>
                                <Th textAlign="center">Undidade (Viabilidade)</Th>
                                <Th textAlign="center">Unidade (Aprovação)</Th>
                                <Th textAlign="center">Data</Th>
                                <Th textAlign="center">Tipo</Th>
                                <Th textAlign="center">Ações</Th>

                              </Tr>
                            </Thead>
                            <Tbody>
                              {data.map((i) => (
                                <Tr key={i.id} >

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i.message}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i?.unit?.name}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i?.unit?.name_approvation}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontSize="12px" fontWeight="bold" color="#993b58">{i.formattedDate}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i.typeLabel}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                    <Flex>

                                  {MakeActions(i.type, i)}
                                  <Button
      onClick={() => setSelectedItem(i)}
        size="sm"
        fontSize="sm"
        mr="2"
        bg="wine.200"
        colorScheme="wine"
        height="40px"
        leftIcon={
          <Icon as={RiEye2Fill} fontSize="16" />
        }
      >
      Marcar como visualizada
    </Button>

                                      {/* <IconButton
                                        colorScheme="red"
                                        aria-label="Edit Content"
                                        icon={<Icon as={AiOutlineDelete} size="30" />}
                                        onClick={() => setSelectedItem(i)}
                                      /> */}

                                    </Flex>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>

                          <Pagination
                            totalCountOfRegisters={total}
                            currentPage={page}
                            onPageChange={setPage}
                          />
                      </TabPanel>

                      <TabPanel>
                          <Table colorScheme="blue">
                            <Thead>
                              <Tr>
                                <Th textAlign="center">Notificação</Th>
                                <Th textAlign="center">Undidade (Viabilidade)</Th>
                                <Th textAlign="center">Unidade (Aprovação)</Th>
                                <Th textAlign="center">Data</Th>
                                <Th textAlign="center">Tipo</Th>
                                <Th textAlign="center">Ações</Th>

                              </Tr>
                            </Thead>
                            <Tbody>
                              {dataDeleted.map((i) => (
                                <Tr key={i.id} >

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i.message}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i?.unit?.name}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i?.unit?.name_approvation}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontSize="12px" fontWeight="bold" color="#993b58">{i.formattedDate}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                      <Link color="wine.500" textAlign="center">
                                        <Text fontWeight="bold" color="#993b58">{i.typeLabel}</Text>
                                      </Link>
                                  </Td>

                                  <Td>
                                    <Flex>

                                  {isWideScreen
                                    ? MakeActions(i.type, i)
                                    : (
                                        <IconButton
                                          mr="3"
                                          colorScheme="green"
                                          aria-label="Edit Content"
                                          icon={<Icon as={RiPencilLine} size="30" />}
                                        />
                                      )}
                                    </Flex>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>

                          <Pagination
                            totalCountOfRegisters={totalDeleted}
                            currentPage={pageDeleted}
                            onPageChange={setPageDeleted}
                          />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                )}
        </Box>
      </Flex>
    </Box>
  )
}

export { ProcessTracking }
